import { NavigationGroup } from '@lsq-frontend/common-ui';

export class DashboardNavigationGroups {
    public static readonly Main = NavigationGroup.Main;
    public static readonly CustomerDetailReports = 'customerDetailReports';
    public static readonly FactoringSettings = 'factoringSettings';
    public static readonly ScfDirectSettings = 'scfDirectSettings';
    public static readonly ScfBuyerPortalSettings = 'scfBuyerPortalSettings';
    public static readonly ScfPlatformSettings = 'scfPlatformSettings';
}
